export const USER_ACCOUNT_BLOCKING_TYPES = {
  temporarily_blocked: 'pages.sco-organization-participants.user-account-blocking-types.temporarily-blocked',
  blocked: 'pages.sco-organization-participants.user-account-blocking-types.blocked',
};
